<script setup>
import { ref } from 'vue'
import SelectionChip from '@/components/SelectionChip.vue'

const impactAreas = ref([
  { area_uuid: 'attention-1', area_label: 'Attention' },
  { area_uuid: 'memory-2', area_label: 'Memory' },
  { area_uuid: 'processing-3', area_label: 'Processing Speed' },
  { area_uuid: 'executive-4', area_label: 'Executive Function' }
])

const subjects = ref([
  { value: 'reading', label: 'Reading' },
  { value: 'math', label: 'Math' },
  { value: 'writing', label: 'Writing' },
  { value: 'science', label: 'Science' }
])

const skills = ref([
  { id: 'skill-1', name: 'Communication' },
  { id: 'skill-2', name: 'Collaboration' },
  { id: 'skill-3', name: 'Critical Thinking' },
  { id: 'skill-4', name: 'Creativity' }
])

const selectedPurpleAreas = ref([impactAreas.value[0]])
const selectedBlueSubjects = ref([subjects.value[1]])
const selectedCustomSkills = ref([])
const selectedMultiple = ref([impactAreas.value[0], impactAreas.value[2]])
</script>

<template>
  <div class="space-y-8">
    <!-- Purple Theme -->
    <div class="card">
      <h3 class="header-md pb-4">Purple Theme (Default)</h3>
      <p class="text-sm text-gray-700 mb-4">
        Used for Impact of Disability areas and other purple-themed features.
      </p>
      <SelectionChip
        v-model="selectedPurpleAreas"
        :items="impactAreas"
        item-key="area_uuid"
        item-label="area_label"
        gb-theme="purple"
      />
      <div class="mt-4 text-sm text-gray-700">
        Selected: {{ selectedPurpleAreas.map(a => a.area_label).join(', ') || 'None' }}
      </div>
    </div>

    <!-- Custom Keys -->
    <div class="card">
      <h3 class="header-md pb-4">Custom Item Keys</h3>
      <p class="text-sm text-gray-700 mb-4">
        Using custom <code class="bg-gray-100 px-1 rounded">itemKey</code> and 
        <code class="bg-gray-100 px-1 rounded">itemLabel</code> props.
      </p>
      <SelectionChip
        v-model="selectedCustomSkills"
        :items="skills"
        item-key="id"
        item-label="name"
        gb-theme="purple"
      />
      <div class="mt-4 text-sm text-gray-700">
        Selected: {{ selectedCustomSkills.map(s => s.name).join(', ') || 'None' }}
      </div>
    </div>

    <!-- Multiple Selections -->
    <div class="card">
      <h3 class="header-md pb-4">Multiple Selections</h3>
      <p class="text-sm text-gray-700 mb-4">
        Supports multiple item selection with visual feedback.
      </p>
      <SelectionChip
        v-model="selectedMultiple"
        :items="impactAreas"
        item-key="area_uuid"
        item-label="area_label"
        gb-theme="purple"
      />
      <div class="mt-4 text-sm text-gray-700">
        Selected ({{ selectedMultiple.length }}): {{ selectedMultiple.map(a => a.area_label).join(', ') || 'None' }}
      </div>
    </div>

    <!-- States Demo -->
    <div class="card">
      <h3 class="header-md pb-4">States</h3>
      <div class="space-y-4">
        <div>
          <p class="text-sm font-medium text-gray-700 mb-2">Default (Unselected)</p>
          <SelectionChip
            :model-value="[]"
            :items="[subjects[0]]"
            gb-theme="purple"
          />
        </div>
        <div>
          <p class="text-sm font-medium text-gray-700 mb-2">Selected</p>
          <SelectionChip
            :model-value="[subjects[0]]"
            :items="[subjects[0]]"
            gb-theme="purple"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  @apply rounded-lg border border-gray-300 bg-white p-6 shadow-sm;
}
</style>
